module.exports = __webpack_public_path__ + "img/xiaohongshu.d8383f49.png";